import { css } from '@emotion/css';

export const tableStyles = css`
  .tableWrapper {
    overflow-x: auto;
    margin-top: 3.2rem;
    margin-bottom: 3.2rem;

    table {
      border-collapse: collapse;
      text-indent: 0;
      table-layout: fixed;
      width: 100%;
      overflow: hidden;
    }
    tr {
      border-collapse: unset;
      border-top: 1px solid var(--divider);
      border-bottom: 1px solid var(--divider);
    }
    td:first-child,
    th:first-child {
      border-left: unset;
    }
    td:last-child,
    th:last-child {
      border-right: unset;
    }
    .ProseMirror-widget {
      color: var(--text-placeholder);
    }
    .column-resize-handle {
      position: absolute;
      right: -2px;
      top: 0;
      bottom: 0;
      width: 4px;
      z-index: 20;
      background-color: #adf;
      pointer-events: none;
    }
    td,
    th {
      min-width: 12rem;
      height: 1rem;
      padding: 1.2rem;
      border: 1px solid var(--divider);
      text-align: left;
      vertical-align: top;
      box-sizing: border-box;
      position: relative;
    }
    h1,
    h2,
    h3,
    h4,
    pre,
    blockquote,
    ul,
    ol,
    p {
      margin-top: 0;
    }
    .addColumn {
      width: 4rem;
    }
  }
  .resize-cursor {
    cursor: ew-resize;
    cursor: col-resize;
  }
`;
